import React, { Component } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

export default class Responsive extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };
    return (
    <section className='container-fluid  wraper-testimony' 
    style={{backgroundImage: `url(${'./img/testimony.jpg'})`}}>
      <div className='row m-10-hor'>
        <div className='testimony'>
          <Slider {...settings}>

            <CustomSlide className='itm' index={1}>
              <div className='blockquote'>
                <div className="fa"></div>
                <div className="conesti">
                  <p>
                  E-ticaret işletmemiz için Hangrup'tan kutu ambalaj hizmeti aldık. 
                  Ürünlerimiz artık çok daha profesyonel görünüyor ve nakliye sırasında 
                  hiçbir hasar yaşamadık. Müşteri memnuniyetimiz arttı!
                  </p>
                  <div className="bytesti">
                    Ahmet Yılmaz, E-Ticaret Yöneticisi
                  </div>
                </div>
              </div>
            </CustomSlide>

            <CustomSlide className='itm' index={2}>
              <div className='blockquote'>
                <div className="fa"></div>
                <div className="conesti">
                  <p>
                  Özel tasarım kutu ambalaj ihtiyacımızı Hangrup karşıladı. 
                  Hem dayanıklı hem de estetik açıdan mükemmel ambalajlar ürettiler. 
                  Markamızın değerini artıran bir hizmet aldık.
                  </p>
                  <div className="bytesti">
                    Ayşe Demir, Pazarlama Müdürü
                  </div>
                </div>
              </div>
            </CustomSlide>

            <CustomSlide className='itm' index={3}>
              <div className='blockquote'>
                <div className="fa"></div>
                <div className="conesti">
                  <p>
                  Fabrikamız için Hangrup'un güvenlik sistemlerini tercih ettik. 
                  Kamera ve alarm sistemleri sayesinde işletmemiz çok daha güvende. 
                  Profesyonel kurulum ve 7/24 destek hizmetleri harika!
                  </p>
                  <div className="bytesti">
                    Mehmet Kaya, Fabrika Müdürü
                  </div>
                </div>
              </div>
            </CustomSlide>

            <CustomSlide className='itm' index={4}>
              <div className='blockquote'>
                <div className="fa"></div>
                <div className="conesti">
                  <p>
                  Ofis binamıza Hangrup'un güvenlik sistemlerini kurduk. 
                  Kartlı geçiş sistemi ve kamera entegrasyonu sayesinde 
                  güvenliğimiz maksimum seviyede. Kesinlikle tavsiye ederim.
                  </p>
                  <div className="bytesti">
                    Zeynep Öztürk, İnsan Kaynakları Uzmanı
                  </div>
                </div>
              </div>
            </CustomSlide>

          </Slider>
        </div>
      </div>
    </section>
    );
  }
}
